import { useEffect } from 'react';

export default function useHideBottomNavbar() {
  useEffect(() => {
    hide();
    window.addEventListener('resize', hide);
    return () => {
      unset();
      window.removeEventListener('resize', hide);
    };
  }, []);

  function hide() {
    const element = document.getElementById('bottom-navbar');
    if (element) {
      element.style.display = 'none';
    }
  }

  function unset() {
    const element = document.getElementById('bottom-navbar');
    if (element) {
      element.style.display = 'unset';
    }
  }
}
